export default function Upgrade({ session, onClose }) {

  function handleUpgrade() {
    window.location.href = 'https://buy.stripe.com/6oUbJ179NbJba9yaJrbMQ00'
  }

  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <button onClick={onClose} style={styles.closeBtn}>✕</button>

        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>⚓</div>
          <h2 style={styles.title}>Unlock Anchor Pro</h2>
          <p style={styles.sub}>Everything you need to stay on track</p>
        </div>

        <div style={styles.featureList}>
          {[
            '👥 Accountability pods with real people',
            '🤖 AI coaching available 24/7',
            '📊 Advanced trigger analytics',
            '🏆 Milestone celebrations',
            '🔔 Smart urge notifications',
          ].map((f, i) => (
            <div key={i} style={styles.feature}>
              <p style={styles.featureText}>{f}</p>
            </div>
          ))}
        </div>

        <div style={styles.priceBox}>
          <p style={styles.price}>$9.99<span style={styles.per}>/month</span></p>
          <p style={styles.priceNote}>Cancel anytime</p>
        </div>

        <button style={styles.upgradeBtn} onClick={handleUpgrade}>
          Start Pro — $9.99/mo
        </button>

        <p style={styles.disclaimer}>
          Secure payment via Stripe. Cancel anytime from your account.
        </p>
      </div>
    </div>
  )
}

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    zIndex: 100,
  },
  card: {
    width: '100%',
    maxWidth: 380,
    background: 'linear-gradient(145deg, #1a1040, #0d0d1a)',
    border: '1px solid rgba(167,139,250,0.3)',
    borderRadius: 24,
    padding: 32,
    position: 'relative',
  },
  closeBtn: {
    position: 'absolute',
    top: 16,
    right: 16,
    background: 'none',
    border: 'none',
    color: 'rgba(255,255,255,0.4)',
    fontSize: 18,
    cursor: 'pointer',
  },
  title: {
    color: '#fff',
    fontFamily: 'serif',
    fontSize: 24,
    margin: '0 0 8px',
  },
  sub: {
    color: 'rgba(255,255,255,0.45)',
    fontSize: 14,
    margin: 0,
  },
  featureList: {
    marginBottom: 24,
  },
  feature: {
    padding: '10px 0',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
  },
  featureText: {
    color: 'rgba(255,255,255,0.8)',
    fontSize: 14,
    margin: 0,
  },
  priceBox: {
    textAlign: 'center',
    marginBottom: 20,
  },
  price: {
    color: '#fff',
    fontSize: 40,
    fontFamily: 'serif',
    margin: 0,
  },
  per: {
    fontSize: 16,
    color: 'rgba(255,255,255,0.45)',
  },
  priceNote: {
    color: 'rgba(255,255,255,0.35)',
    fontSize: 12,
    margin: '4px 0 0',
  },
  upgradeBtn: {
    width: '100%',
    padding: 16,
    background: 'linear-gradient(135deg, #7c3aed, #2563eb)',
    border: 'none',
    borderRadius: 14,
    color: '#fff',
    fontSize: 16,
    fontWeight: 700,
    cursor: 'pointer',
    marginBottom: 12,
  },
  disclaimer: {
    color: 'rgba(255,255,255,0.25)',
    fontSize: 11,
    textAlign: 'center',
    margin: 0,
  },
}